import { gsap } from "gsap";

gsap.config({
  force3D: false,
  nullTargetWarn: false,
});

gsap.defaults({
  ease: "power1.out",
});

export const preAnimate = () => {
  setDefaults();
  const master = gsap.timeline();
  master.add(
    showElements([
      ".grm-robot-full",
      ".grm-robot",
      ".grm-portal",
      ".grm-phone-3",
      ".grm-phone-2",
      ".grm-phone-1",
      ".grm-phones",
      ".grm-phone-1 .grm-testing",
      ".grammarly .challenge .hero__content",
      ".grammarly .challenge .animation-btn",
    ])
  );
  return master;
};

export const afterAnimate = () => {
  gsap.set(".grm-monitor", {
    xPercent: 0,
    autoAlpha: 1,
    visibility: "visible",
  });
  gsap.set(".grm-phones", { x: 0, y: 0, scale: 1 });
  gsap.set(".grm-phone-1", { scale: 1 });
  gsap.set(".grm-phone-2", { scale: 1 });
  gsap.set(".grm-phone-3", { scale: 1 });
  gsap.set(".grm-robot-full", { x: 0 });
  gsap.set(".grm-robot", { y: 0 });
  gsap.set(".grm-robot-mask", { autoAlpha: 0, visibility: "hidden" });
  gsap.set(".grm-portal", { scaleX: 1, scaleY: 1 });
  gsap.set(".grm-portal-top", { y: 0 });
  gsap.set(".grm-portal-bottom", { y: 0 });
  gsap.set(".grm-line", { autoAlpha: 1, visibility: "visible" });
  gsap.set(".grm-testing", { autoAlpha: 1, visibility: "visible" });
  gsap.set(".grammarly .challenge__content", {
    autoAlpha: 1,
    visibility: "visible",
    y: 0,
  });
};

const master = gsap.timeline({
  paused: true,
});
export const animation = (setIsFinished) => {
  master
    .add(loadingAnimation(".grm-phone-1 .grm-dot", 0.9, 0.4), 0)
    .add(loadingAnimation(".grm-phone-1 .grm-line", 0, 0.4), "<")
    .add(
      hideElements([".grm-phone-1 .grm-testing", ".grm-phone-1 .grm-dot"], 0.2)
    )
    .add(decreasePhone(".grm-phone-1"))
    .add(enlargePhone(".grm-phone-2"))
    .add(showElements([".grm-phone-2 .grm-testing"], 0.2))
    .add(loadingAnimation(".grm-phone-2 .grm-dot", 0.9, 0.4))
    .add(loadingAnimation(".grm-phone-2 .grm-line", 0, 0.4), "<")
    .add(
      hideElements([".grm-phone-2 .grm-testing", ".grm-phone-2 .grm-dot"], 0.2)
    )
    .add(decreasePhone(".grm-phone-2"))
    .add(enlargePhone(".grm-phone-3"))
    .add(showElements([".grm-phone-3 .grm-testing"], 0.2))
    .add(loadingAnimation(".grm-phone-3 .grm-dot", 0.9, 0.4))
    .add(loadingAnimation(".grm-phone-3 .grm-line", 0, 0.4), "<")
    .add(
      hideElements([".grm-phone-3 .grm-testing", ".grm-phone-3 .grm-dot"], 0.2)
    )
    .add(decreasePhone(".grm-phone-3"))
    .add(robotPortalOpenAnimation(".grm-portal"), "-=2")
    .add(robotAnimation(".grm-robot"), "<0.6")
    .add(robotPortalCloseAnimation(".grm-portal"), "<0.6")
    .add(hideContent(".grammarly .challenge .hero__content"), "-=1.2")
    .add(monitorAnimation(".grm-monitor"), "-=0.5")
    .add(moveToStart(".grm-phones"))
    .add(moveToStart(".grm-robot-full"), "<")
    .add(hideElements(".grm-line", 1), "<")
    .add(showContent(".grammarly .challenge .challenge__content"), "-=0.5")
    .add(showElements(".grm-testing", 0.2))
    .add(loadingAnimation(".grm-phone-1 .grm-dot", 0.9, 0.4), "<")
    .add(loadingAnimation(".grm-phone-1 .grm-line", 0, 0.4), "<")
    .add(loadingAnimation(".grm-phone-2 .grm-dot", 0.9, 0.4), "<")
    .add(loadingAnimation(".grm-phone-2 .grm-line", 0, 0.4), "<")
    .add(loadingAnimation(".grm-phone-3 .grm-dot", 0.9, 0.4), "<")
    .add(loadingAnimation(".grm-phone-3 .grm-line", 0, 0.4), "<")
    .to(".grammarly .challenge .animation-btn", {
      autoAlpha: 0,
      opacity: 0,
      duration: 0.2,
      onComplete: () => {
        setIsFinished(true);
      },
    });
  return master;
};

function showElements(selectors, duration = 0) {
  const tl = gsap.timeline();
  tl.to(selectors, { autoAlpha: 1, opacity: 1, duration });
  return tl;
}

function hideElements(selectors, duration = 0) {
  const tl = gsap.timeline();
  tl.to(selectors, { autoAlpha: 0, opacity: 0, duration });
  return tl;
}

function setDefaults() {
  gsap.set(".grm-monitor", { xPercent: -100 });
  gsap.set(".grm-phones", { x: 820, y: -50, scale: 1.5 });
  gsap.set(".grm-phone", { transformOrigin: "center" });
  gsap.set(".grm-phone-1", { scale: 1.2 });
  gsap.set(".grm-robot-full", { x: 700 });
  gsap.set(".grm-robot", { y: 230 });
  gsap.set(".grm-robot-mask", { y: 230 });
  gsap.set(".grm-portal", { scaleX: 0, scaleY: 0, transformOrigin: "82% 50%" });
  gsap.set(".grm-portal-top", { y: 5 });
  gsap.set(".grm-portal-bottom", { y: -5 });
}

function moveToStart(selector) {
  const tl = gsap.timeline();
  tl.to(selector, { x: 0, y: 0, scale: 1, duration: 1 });
  return tl;
}

function monitorAnimation(selector) {
  const tl = gsap.timeline();
  tl.to(selector, { autoAlpha: 1, opacity: 1, xPercent: 0, duration: 0.5 });
  return tl;
}

function enlargePhone(selector) {
  const tl = gsap.timeline();
  tl.to(selector, { scale: 1.2, duration: 0.3 });
  return tl;
}

function decreasePhone(selector) {
  const tl = gsap.timeline();
  tl.to(selector, {
    scale: 1,
    duration: 0.3,
  });
  return tl;
}

function robotPortalOpenAnimation(selector) {
  const tl = gsap.timeline();
  tl.to(selector, { scaleX: 2.15, scaleY: 1, y: 0, duration: 0.5 });
  return tl;
}

function robotPortalCloseAnimation(selector) {
  const tl = gsap.timeline();
  tl.to(selector, {
    scaleX: 1,
    scaleY: 1,
    duration: 0.3,
  });
  return tl;
}

function robotAnimation(selector) {
  const tl = gsap.timeline();
  tl.to(selector, { y: 0, duration: 0.5 });
  return tl;
}

function loadingAnimation(selector, repeat, stagger) {
  const tl = gsap.timeline();
  tl.to(selector, { autoAlpha: 1, opacity: 1, repeat, stagger });
  return tl;
}

function hideContent(selector) {
  const tl = gsap.timeline();
  tl.to(selector, { autoAlpha: 0, opacity: 0, yPercent: -50, duration: 0.5 });
  return tl;
}

function showContent(selector) {
  const tl = gsap.timeline();
  tl.to(selector, { autoAlpha: 1, opacity: 1, y: 0, duration: 0.5 });
  return tl;
}
